import axios from "axios";

const api = "https://f2r8ymqcse.execute-api.us-east-1.amazonaws.com/prod";
const apiKey = "";

const metroGisServerRoot =
  process.env.REACT_APP_METROGIS_SERVER_ROOT ||
  "https://metrogis.metrodemedellin.gov.co/server2";
const metroGisPortalRoot =
  process.env.REACT_APP_METROGIS_PORTAL_ROOT ||
  "https://metrogis.metrodemedellin.gov.co/portal2";
const metroGisUser = process.env.REACT_APP_METROGIS_USER;
const metroGisPassword = process.env.REACT_APP_METROGIS_PASSWORD;

const camarasServiceUrl =
  process.env.REACT_APP_METROGIS_CISE_SERVICE_URL ||
  `${metroGisServerRoot}/rest/services/Gerencia_social_servicio_cliente/CISE_Camaras/MapServer`;
const camarasLayerIds = (process.env.REACT_APP_METROGIS_CISE_LAYERS || "1,2,3,4,5,6")
  .split(",")
  .map((id) => parseInt(id.trim(), 10))
  .filter((id) => !isNaN(id));

let metroGisTokenCache = null;

const obtenerTokenMetroGis = async () => {
  if (metroGisTokenCache && metroGisTokenCache.expiresAt > Date.now()) {
    return metroGisTokenCache.token;
  }

  const params = new URLSearchParams({
    username: metroGisUser,
    password: metroGisPassword,
    f: "json",
    client: "referer",
    referer: window.location.origin,
    expiration: "60",
  });

  const { data } = await axios.post(
    `${metroGisPortalRoot}/sharing/rest/generateToken`,
    params,
    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
  );

  if (!data?.token) {
    throw new Error("No se obtuvo token de MetroGIS");
  }

  metroGisTokenCache = {
    token: data.token,
    expiresAt: Date.now() + 55 * 60 * 1000,
  };
  return metroGisTokenCache.token;
};

const consultarCamaras = async () => {
  if (!metroGisUser || !metroGisPassword) {
    throw new Error(
      "Faltan REACT_APP_METROGIS_USER / REACT_APP_METROGIS_PASSWORD"
    );
  }

  const token = await obtenerTokenMetroGis();

  const resultados = await Promise.allSettled(
    camarasLayerIds.map((id) =>
      axios.get(`${camarasServiceUrl}/${id}/query`, {
        params: { where: "1=1", outFields: "*", f: "json", token },
      })
    )
  );

  const fallidas = resultados.filter((r) => r.status === "rejected");
  if (fallidas.length) {
    console.error(
      "MetroGIS: no se pudieron consultar algunas sub-capas de cámaras",
      fallidas.map((r) => r.reason)
    );
  }

  const camaras = resultados
    .filter((r) => r.status === "fulfilled")
    .flatMap((r) => r.value.data?.features || []);

  return { camaras };
};

const consultarUrlDashBoard = async () => {
  // const path = `/locations/arcgis/camaras`; // Ruta del evento específico
  const apiUrl =
    "https://hyxntxhtt5.execute-api.us-east-1.amazonaws.com/prod/reports";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        // 'x-api-key': apiKey,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const consultarActividadEspecifica = async (eventId, protocoloId) => {
  const path = `/activities?eventId=${eventId}&protocol_activity_subactivity=${protocoloId}`;

  let apiUrl = `${api}/activities?eventId=${eventId}`;

  if (protocoloId) {
    apiUrl = `${api}${path}`;
  } // Ruta del evento específico

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        "x-api-key": apiKey,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const funcionActividad = async (registro) => {
  const path = `/activities`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json"); // Cambiado a JSON

  let raw = JSON.stringify(registro);

  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-api-key": apiKey,
    },
    body: raw,
    redirect: "follow",
  };

  // const requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: JSON.stringify(registro), // Convertir el objeto a JSON
  //   redirect: 'follow',
  // };

  try {
    const response = await fetch(apiUrl, requestOptions);
    const data = await response.json(); // Parsear la respuesta a JSON
    return data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const consultarLogs = async (service = "events") => {
  // const path = `/locations/arcgis/camaras`; // Ruta del evento específico
  const apiUrl =
    "https://dlpf7d7mtc.execute-api.us-east-1.amazonaws.com/prod/logs";

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: "application/json",
        "x-api-key": process.env.REACT_APP_KEY_EXTRAS || "",
      },
      params: {
        service,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar actividades:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const extraService = {
  consultarCamaras,
  consultarActividadEspecifica,
  funcionActividad,
  consultarUrlDashBoard,
  consultarLogs,
};

export default extraService;
